export default {
  'promoHeader': 'Hast du hieran gedacht?',
  'add':'Hinzufügen',
  'pickSize':'Größe wählen',
  'cartHeader':'Dein Warenkorb:',
  'addUniid':'Füge Namen und Nummer hinzu',
  'remove':'Entfernen',
  'freeDelivery':'Hey, du bekommst einen kostenlosen Versand!',
  'toCheckout':'Zur Kasse gehen',
  'totalPrice':'Total:',
  'totalDiscount':'Rabatt:',
  'deliveryPrice':'Lieferkosten:',
  'size':'Größe:',
  'getTomoz':'',
  'totalVAT':'MwSt.',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}